import vueAxios from 'vue-axios'

function AxiosFactoryFactory (Vue) {
  return {
    create (options) {
      let instance = Vue.axios.create(options)
      instance.interceptors.response.use(response => response.data, error => Promise.reject(error.response))
      return instance
    }
  }
}

export default function axiosFactory (Vue, axios) {
  Vue.use(vueAxios, axios)
  let axiosFactory = AxiosFactoryFactory(Vue)
  Vue.axiosFactory = axiosFactory
  Object.defineProperties(Vue.prototype, {
    axiosFactory
  })
}
